/**
 * WHAT: Barrel export for all password policy compliance components (generic + technology-specific wrappers).
 * WHY: Centralizes imports so routes and other consumers can use `import { OraclePasswordCompliance } from '../compliance'`
 *      without knowing the internal file structure.
 */

export { default as PasswordPolicyCompliance } from './PasswordPolicyCompliance';
export { default as OraclePasswordCompliance } from './OraclePasswordCompliance';

// Technology-specific wrapper components
export { default as MssqlPasswordCompliance } from './MssqlPasswordCompliance';
export { default as MysqlPasswordCompliance } from './MysqlPasswordCompliance';
export { default as PostgresqlPasswordCompliance } from './PostgresqlPasswordCompliance';
export { default as CassandraPasswordCompliance } from './CassandraPasswordCompliance';
